import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import 'react-table-v6/react-table.css';
import { styled } from '@mui/material/styles';
import UseAutoCompleteSearch from '../../../Common/AutoCompleteTypoHeadDropDown';
import { Button } from 'react-bootstrap';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import './TabDrugStyles.scss';
import ReactTable from 'react-table-v6';
import { Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import DrugAccessService from './DrugAccessService';
import swal from 'sweetalert';
import { Pagination } from '@mui/material';
import PageToggleButton from '../../../Common/PageToggleButton';

const FileterLabel = styled('label')`
    display: block;
    font-weight: 700;
    color: #166c9d;
    margin-top: 20px;
    padding-right: 5px;
`;

const FileterButtonLabel = styled('label')`
    display: block;
    font-weight: 700;
    color: #166c9d;
    margin-top: 10px;
    padding-right: 5px;
`;

const ActionDiv = styled('div')`
    height: 40px;
    margin-top: 12px;
    padding-right: 5px;
`;

const ToggleButtons = styled(ToggleButton)({
    '&.Mui-selected, &.Mui-selected:hover': {
        color: 'white',
        backgroundColor: '#166c9d',
    },
});


const AccordionSummaryTab = styled(AccordionSummary)({
    '&.Mui-expanded': {
        backgroundColor: '#E9F2F5',
    },
});

const filterArrRes = [];

class DrugAccessList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ARManagementData: [],
            showPagination: false,
            rowsPerPage: 10,
            page: 1,
            totalCount: 0,
            total: 0,
            filterInUse: false,
            showARModal: false,
            showDisableARModal: false,
            showSaveARModal: false,
            locationName: '',
            departmentFilter: [{ label: 'All' }],
            thereapeuticClassFilter: [{ label: 'All' }],
            specialtyTypeFilter: [{ label: 'All' }],
            value: 'Included',
            expanded: '',
            accordionData: null,
            dataGridData: [],
            noRecordsMessage: 'No Records Found',
            locationInputChange: [],
            gi10InputChange: [],
            setSelectedLocation: null,
            setSelectedGI10: null,
            isIncluded: 1,
            dataGridDataTotal: [],
            includedOrExcludedAll: 'Exclude All',
            loading: false,
        };
        this.drugAccessService = new DrugAccessService();
    }

    handleIncludedExcludedMain = (event) => {
        if (event.target.value == 'Included') {
            this.setState({ isIncluded: 1, value: event.target.value , includedOrExcludedAll: 'Exclude All'});
        } else {
            this.setState({ isIncluded: 0, value: event.target.value , includedOrExcludedAll: 'Include All'});
        }
        const { customerId } = this.props;
        const { setSelectedGI10, setSelectedLocation, rowsPerPage, page, expanded } = this.state;

        this.drugAccessService
            .getAllDrugConfigClassList(customerId, event.target.value == 'Included' ? 1 : 0, setSelectedLocation, setSelectedGI10)
            .then((res) => {
                if (res && res.status === 'Success' && res.data) {
                    this.setState({
                        accordionData: res.data,
                    });
                }
            });

        this.drugAccessService
            .getAllDrugConfigList(
                setSelectedLocation,
                setSelectedGI10,
                event.target.value == 'Included' ? 1 : 0,
                customerId,
                expanded,
            )
            .then((res) => {
                if (res && res.status === 'Success' && res.data) {
                    const { data, totalPages } = this.paginateUI(res.data, rowsPerPage, page);
                    this.setState({
                        dataGridData: data,
                        dataGridDataTotal: res.data,
                        noRecordsMessage: data.length > 0 ? null : '-No Result Found-',
                        totalCount: totalPages,
                        page: parseInt(page, 10),
                    });
                }
            });
    };

    accordionHandleChange = (event) => {
        this.setState((prevState) => ({
            expanded: prevState.expanded == event ? '' : event,
        }));
        const { customerId } = this.props;
        const { setSelectedGI10, setSelectedLocation, isIncluded, rowsPerPage, page } = this.state;

        this.drugAccessService
            .getAllDrugConfigList(setSelectedLocation, setSelectedGI10, isIncluded, customerId, event)
            .then((res) => {
                if (res && res.status === 'Success' && res.data) {
                    const { data, totalPages } = this.paginateUI(res.data, rowsPerPage, page);
                    this.setState({
                        dataGridData: data,
                        dataGridDataTotal: res.data,
                        noRecordsMessage: data.length > 0 ? null : '-No Result Found-',
                        totalCount: totalPages,
                        page: parseInt(page, 10),
                    });
                }
            });
    };

    filterRender = (filter, onChange, field) => {
        return (
            <div style={{ position: 'relative', backgroundColor: '#FFFFFF', paddingLeft: '10px' }}>
                <FontAwesomeIcon icon={faSearch} className="filter-search-icon" />
                <input
                     onChange={event => { onChange(event.target.value) ; this.onFilterRenderChange(event, field)}}
                    value={filter ? filter.value : ''}
                    style={{
                        width: '100%',
                        border: '0px',
                    }} 
                />
            </div>
        );
    };

    onFilterRenderChange = async (event, field) => {
            const { customerId } = this.props;
            const { dataGridData, total , rowsPerPage, page, setSelectedGI10, setSelectedLocation, isIncluded, expanded } = this.state;
           
            if(field){
                if (!event.target.value){
                    filterArrRes.pop(field);
                } else if(!filterArrRes.includes(field)){
                    filterArrRes.push(field);
                } 
            }
            if(!event.target.value && filterArrRes.length == 0){
                const {data} = await this.paginateUI(dataGridData, rowsPerPage, page);
                if (data && data.length > 0 ) {
                this.setState({
                        dataGridData: data,
                        filterInUse: false
                    });
                }
            } else if(dataGridData.length != total){
                    this.drugAccessService
                        .getAllDrugConfigList(
                            setSelectedLocation,
                            setSelectedGI10,
                            isIncluded,
                            customerId,
                            expanded,
                        )
                        .then((res) => {
                                if (res && res.status === 'Success' && res.data) {
                                    this.setState({
                                        dataGridData: res.data,
                                        filterInUse: true
                                    });
                                }
                        });
            }  
        }

    toggleFilter = (redox, classs) => {
        const { dataGridDataTotal } = this.state;
        const { customerId } = this.props;
        let gpi10 = [];
        let gpi = [];
        dataGridDataTotal.forEach((item) => {
            gpi10.push(item.gpi10Code);
            gpi.push(item.gpi);
        });

        if (gpi10 && gpi10.length > 0) {
            if (redox.includes("Include")) {
                swal({
                    className: 'swal-dc',
                    title: 'Are you sure you want to include all ' + classs + ' medications from your drug list?',
                    text: '',
                    icon: 'info',
                    buttons: true,
                    dangerMode: true,
                }).then((included) => {
                    if (included) {
                        this.drugAccessService.updateDrugConfig(customerId, { gpi10: gpi10, gpi: gpi, status: 1 }).then((response) => {

                         if (response && response.status === 'Success') {
                            const { setSelectedGI10, setSelectedLocation, isIncluded, rowsPerPage, page, expanded } =
                                this.state;
                                this.drugAccessService
                                    .getAllDrugConfigList(
                                        setSelectedLocation,
                                        setSelectedGI10,
                                        isIncluded,
                                        customerId,
                                        expanded,
                                    )
                                    .then((res) => {
                                         if (res && res.status === 'Success' && res.data) {
                                                const { data, totalPages } =   this.paginateUI([], rowsPerPage, page);
                                                this.setState({
                                                    dataGridData: data,
                                                    dataGridDataTotal: [],
                                                    noRecordsMessage: data.length > 0 ? null : '-No Result Found-',
                                                    totalCount: totalPages,
                                                    page: parseInt(page, 10),
                                                    loading: false
                                                });
                                                const { isIncluded, setSelectedGI10, setSelectedLocation } = this.state;

                                                this.drugAccessService
                                                .getAllDrugConfigClassList(customerId, isIncluded, setSelectedLocation, setSelectedGI10)
                                                .then((res) => {
                                                    if (res && res.status === 'Success' && res.data) {
                                                        this.setState({
                                                            accordionData: res.data,
                                                        });
                                                    }
                                                });

                                            }
                                    });
                            }
                        });
                    }
                });
            } else {
                swal({
                     className: 'swal-dc',
                    title: 'Are you sure you want to exclude all ' + classs + '  medications from your drug list?',
                    text: '',
                    icon: 'info',
                    buttons: true,
                    dangerMode: true,
                }).then((exclude) => {
                    if (exclude) {
                        this.drugAccessService.updateDrugConfig(customerId, { gpi10: gpi10, gpi: gpi, status: 0 }).then((response) => {
                             if (response && response.status === 'Success') {
                             const { setSelectedGI10, setSelectedLocation, isIncluded, rowsPerPage, page, expanded } =
                                this.state;
                                    this.drugAccessService
                                        .getAllDrugConfigList(
                                            setSelectedLocation,
                                            setSelectedGI10,
                                            isIncluded,
                                            customerId,
                                            expanded,
                                        )
                                        .then((res) => {
                                            if (res && res.status === 'Success' && res.data) {
                                                const { data, totalPages } = this.paginateUI([], rowsPerPage, page);
                                                this.setState({
                                                    dataGridData: data,
                                                    dataGridDataTotal: [],
                                                    noRecordsMessage: data.length > 0 ? null : '-No Result Found-',
                                                    totalCount: totalPages,
                                                    page: parseInt(page, 10),
                                                    loading: false
                                                });
                                                const { isIncluded, setSelectedGI10, setSelectedLocation } = this.state;
                                                this.drugAccessService
                                                .getAllDrugConfigClassList(customerId, isIncluded, setSelectedLocation, setSelectedGI10)
                                                .then((res) => {
                                                    if (res && res.status === 'Success' && res.data) {
                                                        this.setState({
                                                            accordionData: res.data,
                                                        });
                                                    }
                                                });
                                            }
                                        });
                              }
                        });
                    }
                });
            }

            
        }
    };

    /**
     * Component mount method
     */
    componentDidMount() {
        const { customerId } = this.props;
        this.drugAccessService.getAllDrugConfigClassList(customerId, 1, null, null).then((res) => {
            if (res && res.status === 'Success' && res.data) {
                this.setState({ accordionData: res.data });
            }
        });
    }

    onLocationInputChange = (value) => {
        const { customerId } = this.props;
        this.drugAccessService.getAllBrandName(customerId, value).then((res) => {
            if (res && res.status === 'Success' && res.data) {
                this.setState({
                    locationInputChange: res.data,
                });
            }
        });
    };

    onGI10InputChange = (value) => {
        const { customerId } = this.props;
        this.drugAccessService.getAllGPI10(customerId, value).then((res) => {
            if (res && res.status === 'Success' && res.data) {
                this.setState({
                    gi10InputChange: res.data,
                });
            }
        });
    };

    onSelectLocationChange = (value) => {
        if (value) {
            this.setState({
                setSelectedLocation: value.label,
            });
        } else {
            this.setState({
                setSelectedLocation: null,
            });
        }
    };

    onSelectGI10Change = (value) => {
        if (value) {
            this.setState({
                setSelectedGI10: value.label,
            });
        } else {
            this.setState({
                setSelectedGI10: null,
            });
        }
    };

    search = () => {
        const { customerId } = this.props;
        const { isIncluded, setSelectedGI10, setSelectedLocation } = this.state;
        this.drugAccessService
            .getAllDrugConfigClassList(customerId, isIncluded, setSelectedLocation, setSelectedGI10)
            .then((res) => {
                if (res && res.status === 'Success' && res.data) {
                    this.setState({
                        accordionData: res.data,
                    });
                    const { setSelectedGI10, setSelectedLocation, isIncluded, rowsPerPage, page, expanded } = this.state;
                        this.drugAccessService
                            .getAllDrugConfigList(
                                setSelectedLocation,
                                setSelectedGI10,
                                isIncluded,
                                customerId,
                                expanded,
                            )
                            .then((res) => {
                                if (res && res.status === 'Success' && res.data) {
                                    const { data, totalPages } = this.paginateUI(res.data, rowsPerPage, page);
                                    this.setState({
                                        dataGridData: data,
                                        dataGridDataTotal: res.data,
                                        noRecordsMessage: data.length > 0 ? null : '-No Result Found-',
                                        totalCount: totalPages,
                                        page: parseInt(page, 10),
                                        loading: false
                                    });
                                }
                            });
                }
            });
    };

    clear = () => {
        this.setState({
            isIncluded: 1,
            value: 'Included',
            setSelectedGI10: null,
            setSelectedLocation: null,
            includedOrExcludedAll: 'Exclude All',
            expanded: ''
        });
        const { customerId } = this.props;
        this.drugAccessService.getAllDrugConfigClassList(customerId, 1, null, null).then((res) => {
            if (res && res.status === 'Success' && res.data) {
                this.setState({
                    accordionData: res.data,
                });
            }
        });
    };

    tableRowUpdateClick(rowInfo) {
        const { customerId } = this.props;
        const {
            row: { brand },
            original: { status, gpi10, gpi, gpi10Code },
        } = rowInfo;
        if (status == 'Included' && brand) {
            swal({
                 className: 'swal-dc',
                title: 'Are you sure you want to exclude ' + brand + ' - ' + gpi10 + ' with your drug access listing?',
                text: '',
                icon: 'info',
                buttons: true,
                dangerMode: true,
            }).then((included) => {
                if (included) {
                    this.drugAccessService.updateDrugConfig(customerId, { gpi: [gpi], gpi10: [gpi10Code],  status: 0 }).then((response) => {
                        const { setSelectedGI10, setSelectedLocation, isIncluded, rowsPerPage, page, expanded } =
                            this.state;
                            if (response && response.status === 'Success') {
                                this.drugAccessService
                                    .getAllDrugConfigList(
                                        setSelectedLocation,
                                        setSelectedGI10,
                                        isIncluded,
                                        customerId,
                                        expanded,
                                    )
                                    .then((res) => {
                                        if (res && res.status === 'Success' && res.data) {
                                            const { data, totalPages } = this.paginateUI(res.data, rowsPerPage, page);
                                            this.setState({
                                                dataGridData: data,
                                                dataGridDataTotal: res.data,
                                                noRecordsMessage: data.length > 0 ? null : '-No Result Found-',
                                                totalCount: totalPages,
                                                page: parseInt(page, 10),
                                            });

                                            const { isIncluded, setSelectedGI10, setSelectedLocation } = this.state;
                                                this.drugAccessService
                                                .getAllDrugConfigClassList(customerId, isIncluded, setSelectedLocation, setSelectedGI10)
                                                .then((res) => {
                                                    if (res && res.status === 'Success' && res.data) {
                                                        this.setState({
                                                            accordionData: res.data,
                                                        });
                                                    }
                                                });
                                        }
                                    });
                            }
                    });
                }
            });
        } else {
            swal({
                 className: 'swal-dc',
                title: 'Are you sure you want to include ' + brand + ' - ' + gpi10 + ' with your drug access listing?',
                text: '',
                icon: 'info',
                buttons: true,
                dangerMode: true,
            }).then((exclude) => {
                if (exclude) {
                    this.drugAccessService.updateDrugConfig(customerId, { gpi: [gpi], gpi10: [gpi10Code], status: 1 }).then((response) => {
                        const { setSelectedGI10, setSelectedLocation, isIncluded, rowsPerPage, page, expanded } =
                            this.state;
                             if (response && response.status === 'Success') {
                                    this.drugAccessService
                                        .getAllDrugConfigList(
                                            setSelectedLocation,
                                            setSelectedGI10,
                                            isIncluded,
                                            customerId,
                                            expanded,
                                        )
                                        .then((res) => {
                                            if (res && res.status === 'Success' && res.data) {
                                                const { data, totalPages } = this.paginateUI(res.data, rowsPerPage, page);
                                                this.setState({
                                                    dataGridData: data,
                                                    dataGridDataTotal: res.data,
                                                    noRecordsMessage: data.length > 0 ? null : '-No Result Found-',
                                                    totalCount: totalPages,
                                                    page: parseInt(page, 10),
                                                });

                                                const { isIncluded, setSelectedGI10, setSelectedLocation } = this.state;
                                                this.drugAccessService
                                                .getAllDrugConfigClassList(customerId, isIncluded, setSelectedLocation, setSelectedGI10)
                                                .then((res) => {
                                                    if (res && res.status === 'Success' && res.data) {
                                                        this.setState({
                                                            accordionData: res.data,
                                                        });
                                                    }
                                                });
                                            }
                                        });
                        }
                    });
                }
            });
        }
    }

    async onPageOrPageLoadChange(newPage, perPage) {
        const { customerId } = this.props;
        const { setSelectedGI10, setSelectedLocation, isIncluded, expanded } = this.state;

        if (perPage) {
            this.drugAccessService
                .getAllDrugConfigList(setSelectedLocation, setSelectedGI10, isIncluded, customerId, expanded)
                .then((res) => {
                    if (res && res.status === 'Success' && res.data) {
                        const { data, totalPages } = this.paginateUI(res.data, perPage, newPage);
                        this.setState({
                            dataGridData: data,
                            dataGridDataTotal: res.data,
                            noRecordsMessage: data.length > 0 ? null : '-No Result Found-',
                            totalCount: totalPages,
                            page: parseInt(newPage, 10),
                        });
                    } else {
                        this.setState({
                            dataGridData: [],
                            noRecordsMessage: '-No Customers Found-',
                        });
                    }
                });
        }
    }

    handleChangePage = async (event, newPage) => {
        const { customerId } = this.props;
        const { setSelectedGI10, setSelectedLocation, isIncluded, expanded } = this.state;
        this.setState({ page: newPage });

        this.drugAccessService
            .getAllDrugConfigList(setSelectedLocation, setSelectedGI10, isIncluded, customerId, expanded)
            .then((res) => {
                if (res && res.status === 'Success' && res.data) {
                    const { data } = this.paginateUI(res.data, this.state.rowsPerPage, newPage);
                    this.setState({
                        dataGridData: data,
                        dataGridDataTotal: res.data,
                        noRecordsMessage: data.length > 0 ? null : '-No Result Found-',
                    });
                } else {
                    this.setState({
                        dataGridData: [],
                        noRecordsMessage: '-No Result Found-',
                    });
                }
            });
    };

    paginateUI = (items, perPage, page) => {
        const offset = perPage * (page - 1);
        const totalPages = Math.ceil(items.length / perPage);
        const paginatedItems = items.slice(offset, perPage * page);

        return {
            previousPage: page - 1 ? page - 1 : null,
            nextPage: totalPages > page ? page + 1 : null,
            total: items.length,
            totalPages: totalPages,
            data: paginatedItems,
        };
    };

    render() {
        const { customerName } = this.props;
        const {
            value,
            expanded,
            showPagination,
            dataGridData,
            accordionData,
            noRecordsMessage,
            locationInputChange,
            gi10InputChange,
            rowsPerPage,
            page,
            totalCount,
            filterInUse,
            setSelectedGI10,
            setSelectedLocation,
            includedOrExcludedAll,
        } = this.state;

        return (
            <div className="model-list-box">
                <FileterButtonLabel>Manage Drug Access: {customerName}</FileterButtonLabel>
                <>
                    <div className="body-content use-auto-search">
                        <FileterLabel>Search By : </FileterLabel>
                        <FileterLabel>Brand Name </FileterLabel>
                        <UseAutoCompleteSearch
                            data={locationInputChange}
                            label="Brand Name"
                            noOptionsText="No Brand Name Available"
                            size="small"
                            onSelectChange={this.onSelectLocationChange}
                            onInputChange={this.onLocationInputChange}
                            selected={setSelectedLocation}
                        />

                        <FileterLabel>GPI10 </FileterLabel>
                        <UseAutoCompleteSearch
                            data={gi10InputChange}
                            label="GPI10"
                            noOptionsText="No GPI10 Available"
                            size="small"
                            onSelectChange={this.onSelectGI10Change}
                            onInputChange={this.onGI10InputChange}
                            selected={setSelectedGI10}
                        />
                        <ActionDiv className="action button">
                            <Button className="text-center btn-sm button-action" onClick={this.search}>
                                Search
                            </Button>
                        </ActionDiv>

                        <ActionDiv>
                            <Button className="text-center btn-sm button-action" onClick={this.clear}>
                                Clear
                            </Button>
                        </ActionDiv>
                    </div>

                    <div className="body-content use-auto-search content-end ">
                        <FileterButtonLabel> Display Options:</FileterButtonLabel>
                        <ToggleButtonGroup
                            value={value}
                            onChange={this.handleIncludedExcludedMain}
                            aria-label="Platform"
                            color="primary"
                            exclusive
                        >
                            <ToggleButtons cx={{ height: 50 }} value="Included">
                                Included
                            </ToggleButtons>
                            <ToggleButtons cx={{ height: 50 }} value="Excluded">
                                Excluded
                            </ToggleButtons>
                        </ToggleButtonGroup>
                    </div>

                    <div>
                        {accordionData &&
                            accordionData.map((element) => (
                                <Accordion
                                    key={element.class}
                                    expanded={expanded === element.class}
                                    onChange={() => this.accordionHandleChange(element.class)}
                                    variant="outlined"
                                >
                                    <AccordionSummaryTab
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                    >
                                        <Typography sx={{ width: '90%', flexShrink: 0 }}>{element.class}</Typography>

                                        <Typography>
                                            <div>
                                                <Button
                                                className="text-center btn-sm button-action"
                                                id="view-btn"
                                                value={includedOrExcludedAll}
                                                key={element.class}
                                                onClick={(event) => {
                                                     event.stopPropagation();
                                                     this.toggleFilter(includedOrExcludedAll, element.class);
                                                    }}
                                                >
                                                    {includedOrExcludedAll}
                                                </Button>
                                            </div>
                                        </Typography>
                                    </AccordionSummaryTab>
                                    <AccordionDetails>
                                        <Typography>
                                            <ReactTable
                                                filterable
                                                defaultFilterMethod={(filter, row) =>
                                                    row[filter.id] !== undefined
                                                        ? String(row[filter.id])
                                                              .toLowerCase()
                                                              .includes(filter.value.toLowerCase())
                                                        : false
                                                }
                                                columns={[
                                                    {
                                                        Header: 'Therapeutic Area',
                                                        accessor: 'area',

                                                        Filter: ({ filter, onChange }) =>
                                                            this.filterRender(filter, onChange, 'area'),
                                                    },
                                                    {
                                                        Header: 'Therapeutic Class',
                                                        accessor: 'class',

                                                        Filter: ({ filter, onChange }) =>
                                                            this.filterRender(filter, onChange, 'class'),
                                                    },
                                                    {
                                                        Header: 'Brand Name',
                                                        accessor: 'brand',

                                                        Filter: ({ filter, onChange }) =>
                                                            this.filterRender(filter, onChange, 'brand'),
                                                    },
                                                    {
                                                        Header: 'GPI10',
                                                        accessor: 'gpi10',

                                                        Filter: ({ filter, onChange }) =>
                                                            this.filterRender(filter, onChange, 'gpi10'),
                                                    },
                                                    {
                                                        Header: 'Status',
                                                        accessor: 'status',
                                                        filterable: false,
                                                        width: 100,
                                                    },
                                                    {
                                                        Header: () => <div style={{ textAlign: 'center' }}>Action</div>,
                                                        Cell: MyCell,
                                                        getProps: (state, rowInfo) => ({
                                                            onUpdateClick: () => {
                                                                this.tableRowUpdateClick(rowInfo);
                                                            },
                                                            rowInfo,
                                                        }),
                                                        className: 'td-button-outer',
                                                        minWidth: 110,
                                                        width: 110,
                                                        filterable: false,
                                                    },
                                                ]}
                                                data={dataGridData}
                                                noDataText={noRecordsMessage}
                                                showPagination={showPagination}
                                                minRows={dataGridData.length}
                                                style={
                                                    dataGridData.length >= 1
                                                        ? {
                                                              height: 'calc(100vh - 320px)',
                                                          }
                                                        : {}
                                                }
                                                className="-highlight cursor-pointer w-100"
                                                defaultSorted={[{ id: 'modifiedDate', desc: true }]}
                                            />
                                            <div className="pagination-div">
                                                <Pagination
                                                    showFirstButton
                                                    showLastButton
                                                    disabled={filterInUse}
                                                    component="div"
                                                    count={totalCount}
                                                    page={page}
                                                    rowsPerPage={rowsPerPage}
                                                    onChange={this.handleChangePage}
                                                    variant="outlined"
                                                    shape="rounded"
                                                    sx={{
                                                        '.MuiPaginationItem-root': {
                                                            fontSize: '16px',
                                                            marginTop: '15px',
                                                        },
                                                        '.Mui-selected': {
                                                            backgroundColor: '#135d87 !important',
                                                            color: '#fff',
                                                        },
                                                    }}
                                                />
                                                <PageToggleButton
                                                    rowsPerPageOptions={[10, 20]}
                                                    filterInUse={filterInUse}
                                                    perPageCount={rowsPerPage}
                                                    rowsPerPage={(perPage) => {
                                                        this.setState({ rowsPerPage: perPage });
                                                        this.onPageOrPageLoadChange(1, perPage);
                                                    }}
                                                />
                                            </div>
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            ))}
                    </div>
                </>
            </div>
        );
    }
}

DrugAccessList.propTypes = {
    customerName: PropTypes.object.isRequired,
    customerId: PropTypes.any.isRequired,
};

export default withRouter(DrugAccessList);

/**
 * To return button elements
 * @param {*} param0 Cell info
 */
export function MyCell({
    columnProps: {
        rest: { onUpdateClick, rowInfo },
    },
}) {
    return (
        <Row>
            <Col md={12} className="text-center table-buttons">
                <Button
                    className="text-center btn-sm button-action"
                    id="view-btn"
                    value="Include"
                    onClick={onUpdateClick}
                >
                    {rowInfo.row.status == 'Included' ? 'Exclude' : 'Include'}
                </Button>
            </Col>
        </Row>
    );
}
MyCell.propTypes = {
    columnProps: PropTypes.shape({
        rest: PropTypes.shape({
            onUpdateClick: PropTypes.func,
            onDisableClick: PropTypes.func,
            onDeleteClick: PropTypes.func,
            onClickRename: PropTypes.func,
            rowInfo: PropTypes.func,
        }),
    }),
};
